import delete_trash from "@assets/icons/delete_outline.svg";
import Button from "@components/global/new/Button/Button";
import Icon from "@components/global/new/Icon/Icon";
import MiniLoader from "@components/global/new/MiniLoader/MiniLoader";
import mainLocationsStore from "@mobx/store/locations";
import { IBackRackItemType3, IRackItem3 } from "@mobx/store/locations/types";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";
import { Tooltip } from "antd";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { ReactNode, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import styles from "./ConnectionInfo.module.scss";

export interface IConnectionInfo3Props {
  readonly children: ReactNode;
  readonly eq: IBackRackItemType3;
  readonly type: EQUIPMENT_TYPE;
  readonly item?: IRackItem3;
}

const useControl = (props: IConnectionInfo3Props) => {
  const rackItem = props.item;
  const [value, setValue] = useState<string>(props.eq.info || "");
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const buildingStore = mainLocationsStore.activeLocation!.activeBuilding!;

  const onCancel = () => setOpen(false);

  const onApply = async () => {
    if (!rackItem?.types) return;
    setLoading(true);
    buildingStore.setCanUndo();
    setLoading(false);
  };

  const toggleOpen = () => setOpen((prev) => !prev);

  const onDeleteEquipment = () => {
    // TODO: сопряжение со схемами
  };

  useEffect(() => {
    const onCancelEvent = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", onCancelEvent);

    return () => document.removeEventListener("keydown", onCancelEvent);
  }, []);

  return {
    value,
    open,
    loading,

    setValue,
    onCancel,
    onApply,
    setOpen: toggleOpen,
    onDeleteEquipment,
  };
};

const ConnectionInfo3 = observer((props: IConnectionInfo3Props) => {
  const { formatMessage } = useIntl();
  const control = useControl(props);
  return (
    <Tooltip
      placement='right'
      trigger={["hover", "click"]}
      open={control.open}
      overlayInnerStyle={{ background: "#fff" }}
      color='#fff'
      onOpenChange={control.setOpen}
      title={
        <div className={styles.wrapper}>
          <Icon
            src={delete_trash}
            className={styles.delete_icon}
            onClick={control.onDeleteEquipment}
          />
          <div
            className={cn(styles.text_wrapper, {
              [styles.loading]: control.loading,
            })}
          >
            <textarea
              value={control.value}
              onChange={(e) => control.setValue(e.target.value)}
              placeholder={formatMessage(
                {
                  id: "location.equipment.connection_info.placeholder",
                },
                {
                  type:
                    props.type === EQUIPMENT_TYPE.ELECTRICAL
                      ? formatMessage({
                          id: "location.available_equipment.electrical",
                        })
                      : formatMessage({
                          id: "location.available_equipment.network",
                        }),
                }
              )}
              tabIndex={0}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
            {control.loading && <MiniLoader className={styles.loading_icon} />}
          </div>
          <div className={styles.btns}>
            <Button className={styles.btn} onClick={control.onCancel} white>
              {formatMessage({
                id: "location.equipment.connection_info.cancel",
              })}
            </Button>
            <Button className={styles.btn} onClick={control.onApply}>
              {formatMessage({
                id: "location.equipment.connection_info.apply",
              })}
            </Button>
          </div>
        </div>
      }
    >
      {props.children}
    </Tooltip>
  );
});

ConnectionInfo3.displayName = "ConnectionInfo3";

export default ConnectionInfo3;